import { Singleton } from "../tools/Singleton";


export class LocalizationManager extends Singleton{

    static locale:string =  'en';
    static cache:any = null;

    public setLocale(language:string|null){
        LocalizationManager.locale = language||'en';
    }

    static getText(id:string):string{
        if(this.cache==null){
            console.error('Undefined Localization Cache.');
        }
        let locale_id = this.locale;
        let locale = this.cache[this.locale];
        if(locale==null){
            return `{{Missing ${locale} Locale Definition.}}`;
        }
        
        return this.cache[this.locale][locale_id].data[id].text || `{{Missing ${locale}.${id} string definition.}}`;
    }
    static getStyle(id:string):any{
        if(this.cache==null){
            console.error('Undefined Localization Cache.');
        }
        let locale_id = this.locale;
        let locale = this.cache[this.locale];
        if(locale==null){
            return `{{Missing ${locale} Locale Definition.}}`;
        }
        return this.cache[this.locale][locale_id].data[id].style || undefined;
    }

    static getLoremIpsum():string{
        return "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ac tincidunt diam. Etiam luctus est id nibh eleifend, in venenatis odio rutrum. Donec lacinia tortor libero, a venenatis ante placerat eget. In vel nisi commodo, vulputate massa tempor, blandit elit. Etiam eget arcu id est porttitor blandit ut at dolor. Integer a fringilla erat, luctus rutrum orci. Suspendisse ullamcorper convallis nisi, a facilisis mi iaculis bibendum. Praesent gravida lectus id rhoncus pretium. Morbi sit amet sollicitudin dolor, at dapibus ligula. Donec pharetra, sapien varius hendrerit suscipit, magna massa dictum tortor, ac tincidunt lectus sapien ac lorem.";
    }
}